import {
  START_LOAD_BUSINESS_PLAN,
  SUCCESS_LOAD_BUSINESS_PLAN,
  ERROR_LOAD_BUSINESS_PLAN,
} from 'store/actions/businessPlan'

import {isEmpty} from 'lodash'

const initialState = {
  businessPlanData: [],
  isLoading: false,
  isLoaded: false,
  isError: false,
}
const businessPlan = (state = initialState, action) => {
  switch (action.type) {
    case START_LOAD_BUSINESS_PLAN: {
      return {
        ...state,
        isLoading: true,
      }
    }
    case SUCCESS_LOAD_BUSINESS_PLAN: {
      const {data} = action
      return {
        ...state,
        businessPlanData: data,
        isLoading: false,
        isLoaded: !isEmpty(data),
      }
    }
    case ERROR_LOAD_BUSINESS_PLAN: {
      return {
        ...state,
        isError: true,
      }
    }
    default:
      return state
  }
}

export default businessPlan
